import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CasoTareaService } from 'src/app/services/casos_tareas.service';
import { NotificacionService } from 'src/app/services/notificaciones.service';

@Component({
  selector: 'app-asignar-usuario-modal',
  templateUrl: './asignar-usuario-modal.component.html',
  styleUrls: ['./asignar-usuario-modal.component.scss']
})
export class AsignarUsuarioModalComponent implements OnInit {

  @ViewChild('users') users

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AsignarUsuarioModalComponent>,
    public _caso: CasoTareaService,
    public _snackbar: MatSnackBar,
    public _notification: NotificacionService,

  ) { }

  ngOnInit(): void {
    console.log(this.data.users)
  }
  submit: boolean = false
id
  select(){
     if(this.data._id) {
      this.id = this.data.users.find((user:any)=>user.correo === this.users.selectedOptions.selected[0]?.value)
      this.data.asignadoA = this.users.selectedOptions.selected[0]?.value
      this.data.asignadoAID = this.id.id_usuarios
      this.data.historial.push({
        usuario: `${sessionStorage.getItem("correo")}`,
        realizo:`Caso editado`,
        date: new Date()
      })
      this.data.historial
      this._caso.put(this.data._id,this.data).subscribe(async (response:any)=>{
        this._snackbar.open("Caso editado con Éxito","x")
        this.submit = false
        if(this.id){
          const resp = await this._notification.asignarCaso(this.id.id_usuarios,response.numero_caso).toPromise()
        }
      })
      this.dialogRef.close({correo:this.users.selectedOptions.selected[0]?.value,id:this.id.id_usuarios})
     }else{
      this.id = this.data.users.find((user:any)=>user.correo === this.users.selectedOptions.selected[0]?.value)
      this.dialogRef.close({correo:this.users.selectedOptions.selected[0]?.value,id:this.id.id_usuarios})
     }
  }
  
}
